import { Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup, FormGroupDirective } from '@angular/forms';
import { distinctUntilChanged } from 'rxjs/operators';
import { EStatus } from '../../models/general-enums';
import { EventsService } from '../../services/events.service';

@Component({
  selector: 'lib-events',
  templateUrl: './events.component.html',
  styleUrls: ['./events.component.css']
})
export class EventsComponent implements OnInit {

  @Input() public data: any;
  @Input() public settings: any;
  
  filtersForm = new FormGroup({
    eventCategory: new FormControl(null)
  })
  
  currentDate: string;

  constructor(public eventsService: EventsService) { }

  ngOnInit() {

    const date = new Date();

    const stringFromDate = {
      year: date.getFullYear(),
      month: date.getMonth() + 1,
      date: date.getDate()
    }

    this.currentDate = `${stringFromDate.year}-${stringFromDate.month}-${stringFromDate.date}`;

    this.filtersForm.valueChanges
      .subscribe(
        (newValue) => {
          const payload = {
            fromDate: this.currentDate,
            status: EStatus.Published.toString(),
          };

          if (newValue.eventCategory) { Object.assign(payload, { categoryId: newValue.eventCategory }) }
          this.eventsService.getEventsList(payload).subscribe()
        }
      )
  }

}
